import lazyLoadOnRender from '../lazy/loadOnRender';

const RebrandingBanner = () => import(/* webpackChunkName: "4-feat-rebranding-banner" */ './RebrandingBanner');

export default lazyLoadOnRender({ loader: RebrandingBanner });
